import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var FORM_DATA = {
  imageurl: '',
  link_type: '1',
  link_value: '',
  sort: '1',
  name: '',
  dynamic_tag: ''
};
import draggable from 'vuedraggable';
import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import configMenu from '@/views/custom-layout/components/configMenu.vue';
import { getPictureByKey } from '@/views/custom-layout/api';
import { isEmpty, guid } from '@/utils';
export default {
  name: 'icon_config',
  components: {
    uploadFile: uploadFile,
    draggable: draggable,
    pictureLibrary: pictureLibrary,
    configMenu: configMenu
  },
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    childrenMenuList: Array,
    customerModuleList: Array,
    eBookCategoryList: Array,
    aBookCategoryList: Array,
    customerPackageList: Array,
    systemMenus: Object,
    tabListFlat: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  filters: {
    idFormat: function idFormat(v) {
      return {
        1: '通用金刚区(默认有一级业务菜单,可修改)',
        2: '实体菜单金刚区(默认有实体业务菜单,可修改)',
        3: '方形金刚区'
      }[v];
    }
  },
  data: function data() {
    return {
      colsList: [{
        label: '5列（96*96）',
        value: '5',
        col_num: 5
      }, {
        label: '5列（84*84）',
        value: '5-1',
        col_num: 5
      }, {
        label: '4列（110*110）',
        value: '4',
        col_num: 4
      }, {
        label: '3列（190*190）',
        value: '3',
        col_num: 3
      }],
      colsEnum: {},
      fileList: [],
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      showPictureLibrary: false,
      pictureInfo: {},
      pictureList: [],
      updateIndex: 0,
      pictureIndex: 1,
      depot: {},
      activeText: 'category',
      categoryDialog: false,
      dialogForm: {},
      currentCategoryIndex: -1,
      errorIndex: [],
      dialogLoading: false,
      dialogRules: {
        cols: [{
          required: true,
          message: '列数不可为空',
          trigger: 'change'
        }],
        is_open_row_fold: [{
          required: true,
          message: '行数是否开启折叠不可为空',
          trigger: 'change'
        }],
        fold_start_row: [{
          required: true,
          message: '折叠起始行不可为空',
          trigger: 'change'
        }],
        expand_btn_text: [{
          required: true,
          message: '展开按钮文案不可为空',
          trigger: 'change'
        }, {
          max: 10,
          message: '最多10个字',
          trigger: 'change'
        }],
        fold_btn_text: [{
          required: true,
          message: '收起按钮文案不可为空',
          trigger: 'change'
        }, {
          max: 20,
          message: '最多20个字',
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    deleteImg: function deleteImg() {
      var _this = this;
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this.value.config.bg_image = '';
      });
    },
    sleep: function sleep() {
      var timer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
      return new Promise(function (resolve) {
        setTimeout(function () {
          resolve();
        }, timer);
      });
    },
    onConfirm: function onConfirm() {
      var _this2 = this;
      var maxIndex = this.dialogForm.value.length;
      var validFunc = function validFunc() {
        return new Promise(function (resolve) {
          _this2.$nextTick(function () {
            var item = _this2.dialogForm.value[_this2.currentCategoryIndex];
            var validKeys = Object.keys(item).map(function (i) {
              return "value.".concat(_this2.currentCategoryIndex, ".").concat(i);
            }); // 将当前项表单key作为数组取出来 使用表单校验方法
            _this2.$refs.dialogForm.validateField(validKeys, function (valid) {
              resolve(valid);
            });
          });
        });
      };
      this.dialogLoading = true;
      // 增加一个延时器，展示v-loading
      setTimeout(function () {
        _this2.$refs.dialogForm.validate(/*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(valid) {
            var index, validFail;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  _this2.value.dialogFormValid = valid;
                  if (!valid) {
                    _context.n = 7;
                    break;
                  }
                  _this2.errorIndex = []; // value中表单校验失败下标
                  // 外围表单校验通过 继续校验value中模块数据
                  index = 0;
                case 1:
                  if (!(index < maxIndex)) {
                    _context.n = 5;
                    break;
                  }
                  _this2.currentCategoryIndex = index;
                  _context.n = 2;
                  return _this2.sleep();
                case 2:
                  _context.n = 3;
                  return validFunc();
                case 3:
                  validFail = _context.v;
                  // 按顺序校验value中每项表单
                  if (validFail) {
                    // 有校验失败项，拿到错误信息，并将对应下标存入数组，进行样式标红
                    _this2.errorIndex.push(_this2.currentCategoryIndex);
                    // break // 产品要求不需要中途跳出，全部轮询一遍
                  }
                case 4:
                  index++;
                  _context.n = 1;
                  break;
                case 5:
                  if (!_this2.errorIndex.length) {
                    _context.n = 6;
                    break;
                  }
                  _this2.value.dialogFormValid = false;
                  _this2.dialogLoading = false;
                  _this2.currentCategoryIndex = _this2.errorIndex[0]; // 定位到第一个有错误信息的模块
                  _this2.$message.error('请将红框内模块信息按规则填写完整');
                  return _context.a(2);
                case 6:
                  _this2.value.config = _objectSpread(_objectSpread({}, _this2.value.config), _this2.dialogForm);
                  _this2.categoryDialog = false;
                  _this2.$emit('saveConfig');
                case 7:
                  _this2.dialogLoading = false;
                case 8:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }, 10);
    },
    chooseItem: function chooseItem(item, index) {
      this.currentCategoryIndex = index;
    },
    generateClass: function generateClass(index) {
      var totalCols = this.dialogForm.total_cols || this.colsEnum[this.dialogForm.cols];
      var dialogCols = this.Styles['--colsDialog'];
      var colIndex = index % totalCols;
      if ((colIndex + 1) % dialogCols === 0) {
        return 'split';
      }
      return '';
    },
    setCategory: function setCategory() {
      var _this3 = this;
      var defaultIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var configData = JSON.parse(JSON.stringify(this.value.config));
      var total_cols = configData.total_cols || this.colsEnum[configData.cols];
      this.currentCategoryIndex = defaultIndex;
      this.errorIndex = [];
      this.categoryDialog = true;
      this.dialogLoading = true;
      setTimeout(function () {
        _this3.dialogForm = _objectSpread(_objectSpread({}, configData), {}, {
          total_cols: total_cols
        });
        _this3.dialogLoading = false;
      }, 10);
    },
    checkTotalCols: function checkTotalCols(rule, value) {
      var cols = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
      var callback = arguments.length > 3 ? arguments[3] : undefined;
      if (!/^[0-9]*$/.test(value)) {
        callback('请填写数字格式，仅限正整数');
      } else if (Number(value) < Number(this.colsEnum[cols])) {
        callback('总列数不得小于单屏列数');
      } else {
        callback();
      }
    },
    changeBorderStyle: function changeBorderStyle(val) {
      if (val === '1') {
        this.value.config.border_none = [];
      }
    },
    changeLine: function changeLine(line) {
      var _this$value$config$bo;
      if (this.value.config.border_style === '1') {
        return;
      }
      var index = this.value.config.border_none.findIndex(function (i) {
        return i === line;
      });
      (_this$value$config$bo = this.value.config.border_none).splice.apply(_this$value$config$bo, [index, Number(index > -1)].concat(_toConsumableArray(index > -1 ? [] : [line])));
    },
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this4 = this;
      getPictureByKey({
        key: this.value.key
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this4.pictureInfo = picture;
        _this4.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      if (this.updateIndex === 'bg_image') {
        this.value.config.bg_image = path;
      } else {
        this.dialogForm.value[this.updateIndex]['imageurl'] = path;
      }
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture(pictureIndex, index) {
      // updateIndex: 在onChangePic中对应将组件内第几张图片替换为图库中图片
      // pictureList: 图库中图片列表
      this.pictureList = this.pictureInfo[pictureIndex];
      this.pictureIndex = pictureIndex;
      this.updateIndex = index;
      this.showPictureLibrary = true;
    },
    onUpload: function onUpload(refName) {
      if (refName === 'uploadBG') {
        this.$refs[refName].uploadBanner();
        return;
      }
      this.$refs.uploadBanner[0].uploadBanner();
    },
    checkAmount: function checkAmount(rule, value, callback) {
      if (value && value.length > 3) {
        callback('动态标签字数不得超过三个');
      } else {
        callback();
      }
    },
    changeType: function changeType(id) {
      var _this$value$config_de, _this$value$config_de2;
      this.value.config.total_cols = '5';
      this.value.config.cols = '5';
      this.value.config.is_open_row_fold = '0'; // 是否开启行折叠
      this.value.config.fold_start_row = 2; // 折叠起始行
      this.$set(this.value.config, 'type', id);
      var data = (_this$value$config_de = this.value.config_default_value) === null || _this$value$config_de === void 0 ? void 0 : (_this$value$config_de2 = _this$value$config_de["jgqList".concat(id)]) === null || _this$value$config_de2 === void 0 ? void 0 : _this$value$config_de2.map(function (i) {
        return _objectSpread(_objectSpread({}, FORM_DATA), {}, {
          imageurl: i.imageurl,
          link_value: i.id,
          name: i.name,
          uid: guid()
        });
      });
      this.$set(this.value.config, 'value', data);
    },
    emitUploadFile: function emitUploadFile(res, item) {
      var prop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'imageurl';
      item[prop] = "".concat(this.$ossurl).concat(res);
    },
    handleDelUpload: function handleDelUpload(index, isClose) {
      var _this5 = this;
      if (this.dialogForm.value.length <= 1) {
        this.$message.error('组件至少保留一个数据源');
        return;
      }
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this5.dialogForm.value.splice(index, 1);
        if (isClose) {
          _this5.$nextTick(function () {
            _this5.$refs.form.validate(function (valid) {
              _this5.value.validFail = !valid; //表单校验是否失败
              valid && _this5.$set(_this5.value, 'error', false); // 表单校验通过 将红框标识设为false
              _this5.$emit('closeConfigPanel', {
                value: valid ? _this5.value : '',
                msg_success: valid ? '删除分类成功，变更已保存' : '删除分类成功，完善组件后再保存吧'
              });
            });
          });
        }
      });
    },
    onSuccess: function onSuccess(res) {
      this.$set(item, 'imageurl', res.data.filelink);
    },
    beforUpload: function beforUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    addForm: function addForm() {
      this.dialogForm.value.push(_objectSpread(_objectSpread({}, FORM_DATA), {}, {
        uid: guid()
      }));
    }
  },
  created: function created() {
    var _this6 = this;
    this.colsList.forEach(function (col) {
      _this6.colsEnum[col.value] = col['col_num'];
    });
    // 兼容老数据,赋值默认数据
    if (isEmpty(this.value.config_default_value)) {
      var defaultConfig = this.tabListFlat.find(function (i) {
        return i.key === _this6.value.key;
      });
      this.$set(this.value, 'config_default_value', defaultConfig !== null && defaultConfig !== void 0 && defaultConfig.config_default_value ? JSON.parse(JSON.stringify(defaultConfig.config_default_value)) : {});
    }
    if (isEmpty(this.value.config)) {
      var _this$value$config_de3, _this$value$config_de4;
      var type = this.value.config_default_value.typeList[0].id;
      var _value = (_this$value$config_de3 = this.value.config_default_value) === null || _this$value$config_de3 === void 0 ? void 0 : (_this$value$config_de4 = _this$value$config_de3["jgqList".concat(type)]) === null || _this$value$config_de4 === void 0 ? void 0 : _this$value$config_de4.map(function (i) {
        return _objectSpread(_objectSpread({}, FORM_DATA), {}, {
          imageurl: i.imageurl,
          link_value: i.id,
          name: i.name,
          uid: guid()
        });
      });
      this.$set(this.value, 'config', {
        type: type,
        enable_dynamic_tags: '0',
        bg_style: 1,
        bg_color: '',
        border_style: '1',
        border_none: [],
        rows: '1',
        cols: '5',
        total_cols: '5',
        value: _value
      });
    }
    var _this$value$config = this.value.config,
      _this$value$config$ma = _this$value$config.margin_top,
      margin_top = _this$value$config$ma === void 0 ? 15 : _this$value$config$ma,
      _this$value$config$z_ = _this$value$config.z_index,
      z_index = _this$value$config$z_ === void 0 ? 2 : _this$value$config$z_,
      _this$value$config$bg = _this$value$config.bg_style,
      bg_style = _this$value$config$bg === void 0 ? 1 : _this$value$config$bg,
      _this$value$config$bg2 = _this$value$config.bg_color,
      bg_color = _this$value$config$bg2 === void 0 ? '' : _this$value$config$bg2,
      _this$value$config$ti = _this$value$config.title,
      title = _this$value$config$ti === void 0 ? '' : _this$value$config$ti,
      _this$value$config$ti2 = _this$value$config.title_position,
      title_position = _this$value$config$ti2 === void 0 ? 'left' : _this$value$config$ti2,
      _this$value$config$bg3 = _this$value$config.bg_image,
      bg_image = _this$value$config$bg3 === void 0 ? '' : _this$value$config$bg3,
      _this$value$config$ti3 = _this$value$config.title_font_size,
      title_font_size = _this$value$config$ti3 === void 0 ? 34 : _this$value$config$ti3,
      _this$value$config$ti4 = _this$value$config.title_color,
      title_color = _this$value$config$ti4 === void 0 ? '#333333' : _this$value$config$ti4,
      _this$value$config$ca = _this$value$config.category_font_size,
      category_font_size = _this$value$config$ca === void 0 ? 24 : _this$value$config$ca,
      _this$value$config$ca2 = _this$value$config.category_color,
      category_color = _this$value$config$ca2 === void 0 ? '#333333' : _this$value$config$ca2,
      _this$value$config$ta = _this$value$config.tag_font_size,
      tag_font_size = _this$value$config$ta === void 0 ? 20 : _this$value$config$ta,
      _this$value$config$ta2 = _this$value$config.tag_color,
      tag_color = _this$value$config$ta2 === void 0 ? '#ffffff' : _this$value$config$ta2,
      _this$value$config$co = _this$value$config.cols,
      cols = _this$value$config$co === void 0 ? '5' : _this$value$config$co,
      total_cols = _this$value$config.total_cols,
      _this$value$config$is = _this$value$config.is_open_row_fold,
      is_open_row_fold = _this$value$config$is === void 0 ? '0' : _this$value$config$is,
      _this$value$config$fo = _this$value$config.fold_start_row,
      fold_start_row = _this$value$config$fo === void 0 ? 2 : _this$value$config$fo,
      _this$value$config$ex = _this$value$config.expand_btn_text,
      expand_btn_text = _this$value$config$ex === void 0 ? '展开更多' : _this$value$config$ex,
      _this$value$config$fo2 = _this$value$config.fold_btn_text,
      fold_btn_text = _this$value$config$fo2 === void 0 ? '收起' : _this$value$config$fo2,
      _this$value$config$va = _this$value$config.value,
      value = _this$value$config$va === void 0 ? [] : _this$value$config$va;
    this.$set(this.value, 'config', _objectSpread(_objectSpread({}, this.value.config), {}, {
      // 兼容新老组件 预置数据 start
      margin_top: margin_top,
      z_index: z_index,
      bg_style: bg_style,
      bg_color: bg_color,
      title: title,
      title_position: title_position,
      bg_image: bg_image,
      title_font_size: title_font_size,
      title_color: title_color,
      category_font_size: category_font_size,
      category_color: category_color,
      tag_font_size: tag_font_size,
      tag_color: tag_color,
      cols: cols,
      total_cols: total_cols || this.colsEnum[cols],
      is_open_row_fold: is_open_row_fold + '',
      fold_start_row: fold_start_row,
      expand_btn_text: expand_btn_text,
      fold_btn_text: fold_btn_text,
      value: value.map(function (i) {
        return _objectSpread(_objectSpread({}, i), {}, {
          uid: guid()
        });
      })
      // 兼容新老组件 预置数据 end
    }));
    this.getPicture();
  },
  computed: {
    Styles: function Styles() {
      return {
        '--totalColsDialog': this.dialogForm.total_cols || this.colsEnum[this.dialogForm.cols],
        '--colsDialog': this.colsEnum[this.dialogForm.cols] || 5
      };
    },
    getBorderBoxClass: function getBorderBoxClass() {
      var _this$value$config2 = this.value.config,
        bg_style = _this$value$config2.bg_style,
        border_none = _this$value$config2.border_none;
      var className = [];
      if (bg_style !== 2) {
        return className.join(' ');
      }
      var enumClass = {
        1: 'top',
        2: 'right',
        3: 'bottom',
        4: 'left'
      };
      var borderNoneList = border_none.map(function (i) {
        return "border-hide-".concat(enumClass[i]);
      });
      className = className.concat(borderNoneList);
      return className.join(' ');
    }
  }
};